// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/build/v1/build.proto" (package "viam.app.build.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { BuildService } from "./build";
import type { StartPackageBuildResponse } from "./build";
import type { StartPackageBuildRequest } from "./build";
import type { StartSourceUploadBuildResponse } from "./build";
import type { StartSourceUploadBuildRequest } from "./build";
import type { StartReloadBuildResponse } from "./build";
import type { StartReloadBuildRequest } from "./build";
import type { ClientStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { UnlinkOrgResponse } from "./build";
import type { UnlinkOrgRequest } from "./build";
import type { LinkOrgResponse } from "./build";
import type { LinkOrgRequest } from "./build";
import type { RemoveAppLinkResponse } from "./build";
import type { RemoveAppLinkRequest } from "./build";
import type { ListAppLinksResponse } from "./build";
import type { ListAppLinksRequest } from "./build";
import type { ListRepoLinksResponse } from "./build";
import type { ListRepoLinksRequest } from "./build";
import type { UnlinkRepoResponse } from "./build";
import type { UnlinkRepoRequest } from "./build";
import type { LinkRepoResponse } from "./build";
import type { LinkRepoRequest } from "./build";
import type { ListJobsResponse } from "./build";
import type { ListJobsRequest } from "./build";
import type { GetLogsResponse } from "./build";
import type { GetLogsRequest } from "./build";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { StartBuildResponse } from "./build";
import type { StartBuildRequest } from "./build";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
// Note on ID types:
// build_id: The 'parent' ID for a set of builds of module@version. Builds contain multiple jobs. This ID is globally unique.

/**
 * 2023-11-28: Unstable API. Will change.
 *
 * @generated from protobuf service viam.app.build.v1.BuildService
 */
export interface IBuildServiceClient {
    /**
     * Asynchronously start a build of a Viam module, with one job per platform.
     *
     * @generated from protobuf rpc: StartBuild(viam.app.build.v1.StartBuildRequest) returns (viam.app.build.v1.StartBuildResponse);
     */
    startBuild(input: StartBuildRequest, options?: RpcOptions): UnaryCall<StartBuildRequest, StartBuildResponse>;
    /**
     * Fetch logs from a single job of a single build.
     *
     * @generated from protobuf rpc: GetLogs(viam.app.build.v1.GetLogsRequest) returns (stream viam.app.build.v1.GetLogsResponse);
     */
    getLogs(input: GetLogsRequest, options?: RpcOptions): ServerStreamingCall<GetLogsRequest, GetLogsResponse>;
    /**
     * List the jobs for a module ordered by (build start time, alphabetical platform).
     *
     * @generated from protobuf rpc: ListJobs(viam.app.build.v1.ListJobsRequest) returns (viam.app.build.v1.ListJobsResponse);
     */
    listJobs(input: ListJobsRequest, options?: RpcOptions): UnaryCall<ListJobsRequest, ListJobsResponse>;
    /**
     * link a git repo to a module.
     *
     * @generated from protobuf rpc: LinkRepo(viam.app.build.v1.LinkRepoRequest) returns (viam.app.build.v1.LinkRepoResponse);
     */
    linkRepo(input: LinkRepoRequest, options?: RpcOptions): UnaryCall<LinkRepoRequest, LinkRepoResponse>;
    /**
     * delete a module-repo link.
     *
     * @generated from protobuf rpc: UnlinkRepo(viam.app.build.v1.UnlinkRepoRequest) returns (viam.app.build.v1.UnlinkRepoResponse);
     */
    unlinkRepo(input: UnlinkRepoRequest, options?: RpcOptions): UnaryCall<UnlinkRepoRequest, UnlinkRepoResponse>;
    /**
     * list module-repo links owned by user (directly or through orgs).
     *
     * @generated from protobuf rpc: ListRepoLinks(viam.app.build.v1.ListRepoLinksRequest) returns (viam.app.build.v1.ListRepoLinksResponse);
     */
    listRepoLinks(input: ListRepoLinksRequest, options?: RpcOptions): UnaryCall<ListRepoLinksRequest, ListRepoLinksResponse>;
    /**
     * list external oauth apps owned by user (directly or through orgs).
     *
     * @generated from protobuf rpc: ListAppLinks(viam.app.build.v1.ListAppLinksRequest) returns (viam.app.build.v1.ListAppLinksResponse);
     */
    listAppLinks(input: ListAppLinksRequest, options?: RpcOptions): UnaryCall<ListAppLinksRequest, ListAppLinksResponse>;
    /**
     * delete a viam-app link.
     *
     * @generated from protobuf rpc: RemoveAppLink(viam.app.build.v1.RemoveAppLinkRequest) returns (viam.app.build.v1.RemoveAppLinkResponse);
     */
    removeAppLink(input: RemoveAppLinkRequest, options?: RpcOptions): UnaryCall<RemoveAppLinkRequest, RemoveAppLinkResponse>;
    /**
     * add an org to an oauth app link.
     *
     * @generated from protobuf rpc: LinkOrg(viam.app.build.v1.LinkOrgRequest) returns (viam.app.build.v1.LinkOrgResponse);
     */
    linkOrg(input: LinkOrgRequest, options?: RpcOptions): UnaryCall<LinkOrgRequest, LinkOrgResponse>;
    /**
     * remove an org from an oauth app link.
     *
     * @generated from protobuf rpc: UnlinkOrg(viam.app.build.v1.UnlinkOrgRequest) returns (viam.app.build.v1.UnlinkOrgResponse);
     */
    unlinkOrg(input: UnlinkOrgRequest, options?: RpcOptions): UnaryCall<UnlinkOrgRequest, UnlinkOrgResponse>;
    /**
     * upload the local dev environment and build a module for hot reloading
     *
     * @generated from protobuf rpc: StartReloadBuild(stream viam.app.build.v1.StartReloadBuildRequest) returns (viam.app.build.v1.StartReloadBuildResponse);
     */
    startReloadBuild(options?: RpcOptions): ClientStreamingCall<StartReloadBuildRequest, StartReloadBuildResponse>;
    /**
     * upload the local dev environment and build a module to publish to the registry
     *
     * @generated from protobuf rpc: StartSourceUploadBuild(stream viam.app.build.v1.StartSourceUploadBuildRequest) returns (viam.app.build.v1.StartSourceUploadBuildResponse);
     */
    startSourceUploadBuild(options?: RpcOptions): ClientStreamingCall<StartSourceUploadBuildRequest, StartSourceUploadBuildResponse>;
    /**
     * Start a build where the source code is hosted by Viam
     *
     * @generated from protobuf rpc: StartPackageBuild(viam.app.build.v1.StartPackageBuildRequest) returns (viam.app.build.v1.StartPackageBuildResponse);
     */
    startPackageBuild(input: StartPackageBuildRequest, options?: RpcOptions): UnaryCall<StartPackageBuildRequest, StartPackageBuildResponse>;
}
// Note on ID types:
// build_id: The 'parent' ID for a set of builds of module@version. Builds contain multiple jobs. This ID is globally unique.

/**
 * 2023-11-28: Unstable API. Will change.
 *
 * @generated from protobuf service viam.app.build.v1.BuildService
 */
export class BuildServiceClient implements IBuildServiceClient, ServiceInfo {
    typeName = BuildService.typeName;
    methods = BuildService.methods;
    options = BuildService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Asynchronously start a build of a Viam module, with one job per platform.
     *
     * @generated from protobuf rpc: StartBuild(viam.app.build.v1.StartBuildRequest) returns (viam.app.build.v1.StartBuildResponse);
     */
    startBuild(input: StartBuildRequest, options?: RpcOptions): UnaryCall<StartBuildRequest, StartBuildResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartBuildRequest, StartBuildResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Fetch logs from a single job of a single build.
     *
     * @generated from protobuf rpc: GetLogs(viam.app.build.v1.GetLogsRequest) returns (stream viam.app.build.v1.GetLogsResponse);
     */
    getLogs(input: GetLogsRequest, options?: RpcOptions): ServerStreamingCall<GetLogsRequest, GetLogsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLogsRequest, GetLogsResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * List the jobs for a module ordered by (build start time, alphabetical platform).
     *
     * @generated from protobuf rpc: ListJobs(viam.app.build.v1.ListJobsRequest) returns (viam.app.build.v1.ListJobsResponse);
     */
    listJobs(input: ListJobsRequest, options?: RpcOptions): UnaryCall<ListJobsRequest, ListJobsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListJobsRequest, ListJobsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * link a git repo to a module.
     *
     * @generated from protobuf rpc: LinkRepo(viam.app.build.v1.LinkRepoRequest) returns (viam.app.build.v1.LinkRepoResponse);
     */
    linkRepo(input: LinkRepoRequest, options?: RpcOptions): UnaryCall<LinkRepoRequest, LinkRepoResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<LinkRepoRequest, LinkRepoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * delete a module-repo link.
     *
     * @generated from protobuf rpc: UnlinkRepo(viam.app.build.v1.UnlinkRepoRequest) returns (viam.app.build.v1.UnlinkRepoResponse);
     */
    unlinkRepo(input: UnlinkRepoRequest, options?: RpcOptions): UnaryCall<UnlinkRepoRequest, UnlinkRepoResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnlinkRepoRequest, UnlinkRepoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * list module-repo links owned by user (directly or through orgs).
     *
     * @generated from protobuf rpc: ListRepoLinks(viam.app.build.v1.ListRepoLinksRequest) returns (viam.app.build.v1.ListRepoLinksResponse);
     */
    listRepoLinks(input: ListRepoLinksRequest, options?: RpcOptions): UnaryCall<ListRepoLinksRequest, ListRepoLinksResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRepoLinksRequest, ListRepoLinksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * list external oauth apps owned by user (directly or through orgs).
     *
     * @generated from protobuf rpc: ListAppLinks(viam.app.build.v1.ListAppLinksRequest) returns (viam.app.build.v1.ListAppLinksResponse);
     */
    listAppLinks(input: ListAppLinksRequest, options?: RpcOptions): UnaryCall<ListAppLinksRequest, ListAppLinksResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppLinksRequest, ListAppLinksResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * delete a viam-app link.
     *
     * @generated from protobuf rpc: RemoveAppLink(viam.app.build.v1.RemoveAppLinkRequest) returns (viam.app.build.v1.RemoveAppLinkResponse);
     */
    removeAppLink(input: RemoveAppLinkRequest, options?: RpcOptions): UnaryCall<RemoveAppLinkRequest, RemoveAppLinkResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveAppLinkRequest, RemoveAppLinkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * add an org to an oauth app link.
     *
     * @generated from protobuf rpc: LinkOrg(viam.app.build.v1.LinkOrgRequest) returns (viam.app.build.v1.LinkOrgResponse);
     */
    linkOrg(input: LinkOrgRequest, options?: RpcOptions): UnaryCall<LinkOrgRequest, LinkOrgResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<LinkOrgRequest, LinkOrgResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * remove an org from an oauth app link.
     *
     * @generated from protobuf rpc: UnlinkOrg(viam.app.build.v1.UnlinkOrgRequest) returns (viam.app.build.v1.UnlinkOrgResponse);
     */
    unlinkOrg(input: UnlinkOrgRequest, options?: RpcOptions): UnaryCall<UnlinkOrgRequest, UnlinkOrgResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnlinkOrgRequest, UnlinkOrgResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * upload the local dev environment and build a module for hot reloading
     *
     * @generated from protobuf rpc: StartReloadBuild(stream viam.app.build.v1.StartReloadBuildRequest) returns (viam.app.build.v1.StartReloadBuildResponse);
     */
    startReloadBuild(options?: RpcOptions): ClientStreamingCall<StartReloadBuildRequest, StartReloadBuildResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartReloadBuildRequest, StartReloadBuildResponse>("clientStreaming", this._transport, method, opt);
    }
    /**
     * upload the local dev environment and build a module to publish to the registry
     *
     * @generated from protobuf rpc: StartSourceUploadBuild(stream viam.app.build.v1.StartSourceUploadBuildRequest) returns (viam.app.build.v1.StartSourceUploadBuildResponse);
     */
    startSourceUploadBuild(options?: RpcOptions): ClientStreamingCall<StartSourceUploadBuildRequest, StartSourceUploadBuildResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartSourceUploadBuildRequest, StartSourceUploadBuildResponse>("clientStreaming", this._transport, method, opt);
    }
    /**
     * Start a build where the source code is hosted by Viam
     *
     * @generated from protobuf rpc: StartPackageBuild(viam.app.build.v1.StartPackageBuildRequest) returns (viam.app.build.v1.StartPackageBuildResponse);
     */
    startPackageBuild(input: StartPackageBuildRequest, options?: RpcOptions): UnaryCall<StartPackageBuildRequest, StartPackageBuildResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartPackageBuildRequest, StartPackageBuildResponse>("unary", this._transport, method, opt, input);
    }
}
